import { GraphQLQueryClass } from "@harea/component";
import { TWorkingDaysResponse } from "@harea/component";

export class WorkingDayListQuery
    implements GraphQLQueryClass<TWorkingDaysResponse, TResponse>
{
    queryKey: string = "Harea.Vacation.WorkingDay.List.Query";

    gql: string = `
        query workingDayListQuery($pageSize: Float, $page: Float, $data: JSONObject) {
            workingdays(
                filter: {
                    pageSize: $pageSize,
                    page: $page
                    data: $data,
                }
            ) {
                total
                data {
                    id
                    name
                    value
                    startDate
                    endDate
                    year
                    comment
                    isMultiDay
                    isWeeklyRepetitive
                    personnelGroup {
                        id
                    }
                }
            }
        }
    `;

    variables?: any;

    constructor(variables?: any) {
        this.variables = variables;
    }

    mapFn(data: TResponse): TWorkingDaysResponse {
        return data.workingdays;
    }
}

type TResponse = {
    workingdays: TWorkingDaysResponse;
};
